export const RATE_TIP_AUTO_OPEN_EVENT = "rate-tip:auto-open-trigger";

export const RATE_TIP_TRIGGER_TYPES = {
  CALL_STAFF: "call-staff",
  ORDER_MORE: "order-more",
  EXPEDITE_ORDER: "expedite-order",
  ADD_TO_CART: "add-to-cart",
  ORDER_SUBMITTED: "order-submitted",
  BACK_TO_MENU: "back-to-menu",
  CONFIRM_PAYMENT: "confirm-payment",
};

export const RATE_TIP_TRIGGER_BY_ACTION = {
  endCall: "end-call",
  orderSubmitted: RATE_TIP_TRIGGER_TYPES.ORDER_SUBMITTED,
  confirmPayment: RATE_TIP_TRIGGER_TYPES.CONFIRM_PAYMENT,
  callStaff: RATE_TIP_TRIGGER_TYPES.CALL_STAFF,
  orderMore: RATE_TIP_TRIGGER_TYPES.ORDER_MORE,
  expediteOrder: RATE_TIP_TRIGGER_TYPES.EXPEDITE_ORDER,
  addToCart: RATE_TIP_TRIGGER_TYPES.ADD_TO_CART,
  backToMenu: RATE_TIP_TRIGGER_TYPES.BACK_TO_MENU,
};

export const emitRateTipAutoOpenTrigger = (trigger, extra = {}) => {
  if (typeof window === "undefined") return;

  window.dispatchEvent(
    new CustomEvent(RATE_TIP_AUTO_OPEN_EVENT, {
      detail: {
        trigger,
        timestamp: Date.now(),
        ...extra,
      },
    }),
  );
};

export const emitRateTipAutoOpenTriggerByAction = (action, extra = {}) => {
  const trigger = RATE_TIP_TRIGGER_BY_ACTION[action];
  if (!trigger) return;

  emitRateTipAutoOpenTrigger(trigger, extra);
};
